import { createAction } from "../creators";

export default {
  ...createAction("GET_STATIC_DATA", "sort", "key", "token"),
  ...createAction("STATIC_DATA_RETURNED", "sort", "data", "key"),
};
